export default import.meta.ROLLUP_FILE_URL_VRAku6fjghkApIISiBWPzg;